/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import { Link } from 'react-router-dom';
import PostShareButton from 'app/components/common/PostShareButton.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class PostPreview extends React.Component {
	constructor(props) {
		super(props);

		this.repostMethod = this.repostMethod.bind(this);
		this.canRepost = this.canRepost.bind(this);

	}

	canRepost() {
		let hasPreview = false;

		if ((_.isObject(this.props.preview) && Object.keys(this.props.preview).length)) {
			hasPreview = true;
		} else if (this.props.postInfo !== null && this.props.postInfo.pi_content !== undefined) {
			hasPreview = true;
		} else if (this.props.postInfo !== null) {
			hasPreview = true;
		}

		return hasPreview;

	}

	repostMethod() {

		let preview = null;

		if ((_.isObject(this.props.preview) && Object.keys(this.props.preview).length)) {
			preview = this.props.preview;
		} else if (this.props.postInfo !== null && this.props.postInfo.pi_content !== undefined) {
			preview = this.props.postInfo.pi_content;
		} else {
			preview = this.props.postInfo;
		};

		if (preview) {
			this.props.repostMethod({
				preview
			});
		}

	}

	render() {
		let previewContent = null,
			thumb = null,
			previewTitle = null,
			statsLink = null,
			postDate = null,
			postLink = null,
			previewCopy = null,
			showPreview = true,
			previewBody = '',
			image = null;

		if (this.props.postInfo !== null && this.props.postInfo !== undefined && !_.isEmpty(this.props.postInfo)) {
			// add a thumbnail
			if (this.props.postInfo.media && typeof this.props.postInfo.media.length !== "undefined" && this.props.postInfo.media.length > 0) {
				let media = this.props.postInfo.media[0];
				if (media !== undefined && (media.thumb !== "" || media.full !== "")) {
					image = (media.thumb) ? media.thumb : media.full;
					thumb = (
						<div className="post-preview-thumb">
							<img src={image} className="preview-thumb-img"/>
						</div>
					);
				}
			}

			if (!thumb) {
				if (this.props.postInfo.itemInfo !== undefined) {
					if (this.props.postInfo.itemInfo.preview_display !== undefined && this.props.postInfo.itemInfo.previewDisplay === 1) {
						if (this.props.postInfo.itemInfo.imageThumbLink !== undefined && this.props.postInfo.itemInfo.imageThumbLink) {
							thumb = (
								<div className="post-preview-thumb">
									<img src={this.props.postInfo.itemInfo.imageThumbLink} className="preview-thumb-img"/>
								</div>
							);
						}
					}
				}
			}

			previewTitle = "Last Item Posted";

			if (this.props.postInfo.longUrl !== undefined) {
				postLink = (
					<a href={this.props.postInfo.longUrl} target="_blank">{this.props.postInfo.longUrl}</a>
				);
			} else if (this.props.postInfo.link !== undefined) {
				postLink = (
					<a href={this.props.postInfo.link} target="_blank">{this.props.postInfo.link}</a>
				);
			}


			if (this.props.postInfo.message) {
				previewCopy = this.props.postInfo.message;
			} else if (this.props.postInfo.title) {
				previewCopy = this.props.postInfo.title;
			} else if (this.props.postInfo.comment) {
				previewCopy = this.props.postInfo.comment;
			} else if (this.props.postInfo.fbComment) {
				previewCopy = this.props.postInfo.fbComment;
			} else if (this.props.postInfo.status) {
				previewCopy = this.props.postInfo.status;
			} else if (this.props.postInfo.itemInfo !== undefined && this.props.postInfo.itemInfo.title) {
				previewCopy = this.props.postInfo.itemInfo.title;
			} else if (this.props.postInfo.itemInfo !== undefined && this.props.postInfo.itemInfo.summary) {
				previewCopy = this.props.postInfo.itemInfo.summary;
			}

			previewContent = (
				<div className="post-preview-content">
					{thumb}
					<div className="post-preview-date">
						<DateDisplay {...this.props} dateTime={this.props.postTime} dateTimeFormat="long" />
					</div>
					<div className="post-preview-excerpt">
						{previewCopy} {postLink}
					</div>
				</div>
			);
		} else if (!_.isEmpty(this.props.preview)) {
			previewTitle = "Last Item Posted";

			if (this.props.preview.media && this.props.preview.media.length) {
				if (this.props.preview.media[0].thumb !== '' || this.props.preview.media[0].full !== '') {
					image = (this.props.preview.media[0].thumb) ? this.props.preview.media[0].thumb : this.props.preview.media[0].full;
					thumb = (
						<div className="post-preview-thumb">
							<img src={image} className="preview-thumb-img"/>
						</div>
					);
				}
			}

			if (!thumb) {
				if (this.props.preview.itemInfo !== undefined) {
					if (this.props.preview.itemInfo.preview_display !== undefined && this.props.preview.itemInfo.previewDisplay === 1) {
						if (this.props.preview.itemInfo.imageThumbLink !== undefined && this.props.preview.itemInfo.imageThumbLink) {
							thumb = (
								<div className="post-preview-thumb">
									<img src={this.props.preview.itemInfo.imageThumbLink} className="preview-thumb-img"/>
								</div>
							);
						}
					}
				}
			}


			if (this.props.preview.link) {
				postLink = (
					<a href={this.props.preview.link} target="_blank">{this.props.preview.link}</a>
				);
			}


			if (this.props.preview.title) {
				previewCopy = this.props.preview.title;
			} else if (this.props.preview.message) {
				previewCopy = this.props.preview.message;
			} else if (this.props.preview.itemInfo !== undefined && this.props.preview.itemInfo.title) {
				previewCopy = this.props.preview.itemInfo.title;
			} else if (this.props.preview.itemInfo !== undefined && this.props.preview.itemInfo.summary) {
				previewCopy = this.props.preview.itemInfo.summary;
			}

			previewContent = (
				<div className="post-preview-content">
					{thumb}
					<div className="post-preview-date">
						<DateDisplay {...this.props} dateTime={this.props.postTime} dateTimeFormat="long" />
					</div>
					<div className="post-preview-excerpt">
						{previewCopy} {postLink}
					</div>
				</div>
			);

		} else {
			previewTitle = "No recent posts";
			showPreview = false;
		}

		if (showPreview) {
			previewBody = (
 				<div className="item-row">
					<Breakpoint desktop only>
						<PostShareButton postMethod={this.repostMethod} />
					</Breakpoint>
					<div className="item-details curate-item-details">
						{previewContent}
					</div>
				</div>
			);
		}

		let mobileShare = null;
		if (this.canRepost()) {
			mobileShare = (
				<div className="item-share curate-item-share item-share-full">
					<div className="btn-item-share" onClick={this.repostMethod} data-itemid={this.props.itemId} role="button" aria-label="share">
						<span>Share</span>
						<i className="fa fa-share fa-lg"></i>
					</div>
				</div>
			);
		}

		return (
			<div className="post-preview clearfix">
				<div className="post-preview-header">
					<Breakpoint mobile only>
						{mobileShare}
						<div className="post-preview-title">
							{previewTitle}
						</div>
					</Breakpoint>
					<Breakpoint desktop only>
						<div className="post-preview-help">
							<a href="https://support.dlvrit.com/hc/en-us/articles/360005309333" target="_blank">Missing a post?</a>
						</div>
						<div className="post-preview-title">
							{previewTitle}
						</div>
					</Breakpoint>
				</div>
				{previewBody}
			</div>
		);
	}
};

PostPreview.displayName = "PostPreview";

PostPreview.propTypes = {
	postInfo: PropTypes.object,
	postTime: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	preview: PropTypes.object,
	repostMethod: PropTypes.func
};

PostPreview.defaultProps = {
	postInfo: {},
	postTime: 0,
	preview: {},
	repostMethod: null
};

export default PostPreview;
